import { createRouter, createWebHistory } from 'vue-router'
import {useStore} from "vuex";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/lander',
      name: 'lander',
      component: () => import('@/views/Lander.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '/certificates/:certificate_id?',
      name: 'certificates',
      component: () => import('@/views/Certificate.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/views/Faq.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/coaching-sessions',
      name: 'coaching-sessions',
      component: () => import('@/views/CoachingSessions.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: () => import('@/views/Exercises.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/learn',
      name: 'learn',
      component: () => import('@/views/Learn.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/courses',
      name: 'course-materials',
      component: () => import('@/views/Courses.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/learn/courses/:course_slug',
      name: 'courses',
      component: () => import('@/views/Course.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: { viewLevel: 'course' },
    },
    {
      path: '/learn/courses/:course_slug',
      name: 'courses',
      component: () => import('@/views/Course.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: { viewLevel: 'course' },
    },
    {
      path: '/learn/courses/:course_slug/:chapter_id',
      name: 'courses/chapter',
      component: () => import('@/views/Course.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: { viewLevel: 'chapter' },
    },
    {
      path: '/learn/courses/:course_slug/:chapter_id/:section_id',
      name: 'courses/section',
      component: () => import('@/views/Course.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: { viewLevel: 'section' },
    },
    {
      path: '/learn/courses/:course_slug/:chapter_id/activities',
      name: 'courses/chapter/activities',
      component: () => import('@/views/CourseActivities.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: {
        viewLevel: 'chapter',
        showActivities: true,
      },
    },
    {
      path: '/learn/courses/:course_slug/:chapter_id/:section_id/activities',
      name: 'courses/section/activities',
      component: () => import('@/views/CourseActivities.vue'),
      meta: {
        requiresAuth: true,
      },
      props: {
        viewLevel: 'section',
        showActivities: true,
      },
    },
    {
      path: '/documents',
      name: 'documents-materials',
      component: () => import('@/views/Documents.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/request-password-reset',
      name: 'request-password-reset',
      component: () => import('@/views/RequestPasswordReset.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/confirm-password-reset/:token',
      name: 'confirm-password-reset',
      component: () => import('@/views/ConfirmPasswordReset.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/Upload.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/RecordDesktop.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/program-recordings',
      name: 'program-recordings',
      component: () => import('@/views/ProgramRecordings.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/my-recordings',
      name: 'my-recordings',
      component: () => import('@/views/MyRecordings.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/my-courses',
      name: 'my-courses',
      component: () => import('@/views/MyCourses.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/video/:video_id',
      name: 'video',
      component: () => import('@/views/Video.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/shared-with-me',
      name: 'shared-with-me',
      component: () => import('@/views/ProgramRecordings.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: {
        visibility: 'SharedWithMe',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/sessions',
      name: 'sessions',
      component: () => import('@/views/Sessions.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/results/:video_id/:language?',
      name: 'results',
      component: () => import('@/views/Results.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
      props: {
        tab: 0,
      },
    },
    {
      path: '/review/:video_id',
      name: 'review',
      component: () => import('@/views/Review.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/admin/courses/:course_slug',
      name: 'courses/admin',
      component: () => import('@/views/CourseAdmin.vue'),
      meta: {
        requiresAuth: true,
      },
      props: { viewLevel: 'course' },
    },
    {
      path: '/admin/courses/:course_slug/:chapter_id',
      name: 'courses/admin/chapter',
      component: () => import('@/views/CourseAdmin.vue'),
      meta: {
        requiresAuth: true,
      },
      props: { viewLevel: 'chapter' },
    },
    {
      path: '/admin/courses/:course_slug/:chapter_id/:section_id',
      name: 'courses/admin/section',
      component: () => import('@/views/CourseAdmin.vue'),
      meta: {
        requiresAuth: true,
      },
      props: { viewLevel: 'section' },
    },
    {
      path: '/calendar',
      name: 'coach-calendar',
      component: () => import('@/views/Calendar.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs',
      name: 'programs',
      component: () => import('@/views/Programs.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug',
      name: 'program-details',
      component: () => import('@/views/Program.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/program-members',
      name: 'program-members',
      component: () => import('@/views/ProgramMembers.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/program-members/:user_id/stats',
      name: 'student-stats',
      component: () => import('@/views/StudentStats.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/materials/:document_id',
      name: 'programs/materials/document',
      component: () => import('@/views/Document.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/sessions/:session_id',
      name: 'programs/session',
      component: () => import('@/views/Session.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay',
      name: 'roleplay',
      component: () => import('@/views/RoleplayStart.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay/guided',
      name: 'roleplay-guided',
      component: () => import('@/views/RolePlay.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay/quick',
      name: 'roleplay-quick',
      component: () => import('@/views/QuickRoleplayIntent.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay/quick/:session_id',
      name: 'roleplay-quick-confirm',
      component: () => import('@/views/QuickRoleplayConfirm.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/session-report/:session_id',
      name: 'roleplay-session-report',
      component: () => import('@/views/RolePlaySessionReport.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/programs/:program_slug/roleplay-scenarios/:category_slug?',
      name: 'roleplay-scenarios',
      component: () => import('@/views/RoleplaySessionControl.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay-session/:session_id',
      name: 'roleplay-session',
      component: () => import('@/views/RolePlaySessionPreview.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/programs/:program_slug/roleplay-session',
      redirect: to => ({ name: 'roleplay', params: { program_slug: to.params.program_slug } }),
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: () => import('@/views/Error.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/verify-email/:userId/:token',
      name: 'verify-email',
      component: () => import('@/views/Verify.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      redirect: { name: 'not-found' },
    },
    {
      path: '/editor',
      name: 'editor',
      component: () => import('@/views/Editor.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/news/:id',
      name: 'news',
      component: () => import('@/views/News.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },
    {
      path: '/events/:id',
      name: 'event',
      component: () => import('@/views/Event.vue'),
      meta: {
        requiresAuth: true,
        navigation: true,
      },
    },

  ]
})

let entryUrl = null;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const store = useStore();
    // If there's a redirect query param, use it; otherwise use the named route
    const target = to.query.redirect ? { path: to.query.redirect } : { name: 'lander' };

    store.dispatch('users/checkJwt').then(() => {
      if (store.getters['users/isAuth']) {
        if (entryUrl) {
          const url = entryUrl;
          entryUrl = null;
          next(url);
        } else {
          next();
        }
      } else {
        entryUrl = null;
        next({
          ...target,
          query: to.query,
        });
      }
    }).catch((error) => {
      console.error('Error checking JWT:', error);
      const sessionInvalid = error?.response?.status === 401 || error?.authInvalid === true;
      if (!sessionInvalid) {
        next();
        return;
      }
      entryUrl = null;
      next({
        ...target,
        query: to.query,
      });
    });
  } else {
    next();
  }
});

window.addEventListener('vite:preloadError', (event) => {
  window.location.reload();
});

export default router
